/* The same column as the questions it checks. */
.check {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 720px;
  margin: 0 auto;
}

.back {
  align-self: flex-start;
  display: flex;
  align-items: center;
  min-height: 44px;
  font-weight: 700;
  text-underline-offset: 3px;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.title {
  font-size: 28px;
}

.subtitle,
.kept {
  font-size: 15px;
  color: var(--ink-2);
}

/* Lilac, like everything only the patient can see: the answers are still a
 * draft. */
.notice {
  padding: 14px 16px;
  border: var(--outline);
  border-radius: var(--radius-card);
  background: var(--private);
  color: var(--private-ink);
  line-height: 1.45;
}

.list {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-top: 1.5px solid var(--ink);
  color: var(--ink);
  text-decoration: none;
}

.row:first-child {
  border-top: 0;
}

.number {
  flex: 0 0 28px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
}

.item {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  font-size: 15px;
}

.answer {
  font-size: 14px;
  color: var(--ink-2);
}

.missing {
  font-size: 14px;
  font-weight: 700;
  color: var(--private-ink);
}

.edit {
  font-size: 14px;
  font-weight: 700;
}

.send {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px;
  border-radius: var(--radius-card);
  background: var(--sunk);
  line-height: 1.5;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
